import type { TopControlsWheelInfo } from '@/components/top-controls-view/top-controls-view'
import { resolveBaseDiameterInches } from '@/models/base-diameter'
import type { WheelLoaderState } from '@/services/wheel-loader'

/** The header's wheel info. The size reads the same base the pinch snaps
 *  against — the payload size, else the GLB's own (2026-10-05) — times the
 *  pinch multiplier, so the pill always names what is on screen. */
export function projectTopControlsWheelInfo(
  state: WheelLoaderState,
  scaleMultiplier: number,
): TopControlsWheelInfo | null {
  const wi = state.wheelInfo
  if (wi.brandName.length === 0 || wi.modelName.length === 0) return null
  const baseDiameter = resolveBaseDiameterInches({
    wheelInfo: wi,
    glbDiameterInches: state.glbDiameterInches,
  })
  return {
    brandName: wi.brandName,
    modelName: wi.modelName,
    brandLogoURL: wi.brandLogoURL,
    brandLogoDarkURL: wi.brandLogoDarkURL,
    sizes: wi.sizes,
    selectedSize: wi.selectedSize,
    displayDiameterInches:
      baseDiameter != null ? baseDiameter * scaleMultiplier : null,
  }
}
